"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformLayerToJSON = exports.transformJSONToLayer = void 0;

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.map.js");

var _blendModeEnum = require("./blend-mode-enum");

var _boundingRectangle = require("./bounding-rectangle");

var _layerBlur = require("./layer-blur");

var _layerBorder = require("./layer-border");

var _layerFill = require("./layer-fill");

var _layerShadow = require("./layer-shadow");

var _layerTextStyle = require("./layer-text-style");

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformLayerToJSON = function transformLayerToJSON(value) {
  return {
    id: value.id,
    source_id: value.sourceId,
    type: value.type,
    name: value.name,
    rect: (0, _boundingRectangle.transformBoundingRectangleToJSON)(value.rect),
    fills: value.fills && value.fills.map(_layerFill.transformLayerFillToJSON),
    borders: value.borders && value.borders.map(_layerBorder.transformLayerBorderToJSON),
    shadows: value.shadows && value.shadows.map(_layerShadow.transformLayerShadowToJSON),
    blur: value.blur && (0, _layerBlur.transformLayerBlurToJSON)(value.blur),
    opacity: value.opacity,
    blend_mode: value.blendMode && (0, _blendModeEnum.transformBlendModeEnumToJSON)(value.blendMode),
    border_radius: value.borderRadius,
    rotation: value.rotation,
    exportable: value.exportable,
    content: value.content,
    text_styles: value.textStyles && value.textStyles.map(_layerTextStyle.transformLayerTextStyleToJSON),
    layers: value.layers && value.layers.map(transformLayerToJSON),
    component_name: value.componentName
  };
};

exports.transformLayerToJSON = transformLayerToJSON;

var transformJSONToLayer = function transformJSONToLayer(value) {
  return {
    id: value.id,
    sourceId: value.source_id,
    type: value.type,
    name: value.name,
    rect: (0, _boundingRectangle.transformJSONToBoundingRectangle)(value.rect),
    fills: value.fills && value.fills.map(_layerFill.transformJSONToLayerFill),
    borders: value.borders && value.borders.map(_layerBorder.transformJSONToLayerBorder),
    shadows: value.shadows && value.shadows.map(_layerShadow.transformJSONToLayerShadow),
    blur: value.blur && (0, _layerBlur.transformJSONToLayerBlur)(value.blur),
    opacity: value.opacity,
    blendMode: value.blend_mode && (0, _blendModeEnum.transformJSONToBlendModeEnum)(value.blend_mode),
    borderRadius: value.border_radius,
    rotation: value.rotation,
    exportable: value.exportable,
    content: value.content,
    textStyles: value.text_styles && value.text_styles.map(_layerTextStyle.transformJSONToLayerTextStyle),
    layers: value.layers && value.layers.map(transformJSONToLayer),
    componentName: value.component_name
  };
};
/**
 * 
 * @export
 * @interface Layer
 */


exports.transformJSONToLayer = transformJSONToLayer;